<template>
  <div id="app" class="min-h-screen w-screen">
    <transition name="fade">
      <Notification v-if="$store.state.notification.show && shouldShowDashboardNotification"></Notification>
    </transition>
    <router-view />
  </div>
  <!-- <img class="h-auto w-full fixed bottom-0 left-0 contain object-contain select-auto" src="./assets/grass.svg"> -->
  
</template>
<script>
  import Notification from '@/components/Notification.vue';

  export default {
    components: { Notification },
    computed: {
      shouldShowDashboardNotification() {
        return this.$route.path.startsWith('/dashboard') || this.$route.path === '/login';
      }
    },
    watch: {
      // Set meta tags
      $route(to) {
        this.setMeta(to.meta);
      },
    },
    methods: {
      setMeta(meta) {
        document.title = meta.title;
        if(meta.title === undefined)
        {
          document.title = 'Przedszkole';
        }
      }
    }
  }
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');

html, body {
  font-family: 'Poppins', sans-serif;
  overflow-x: hidden;
}

#app {
  font-family: 'Poppins', sans-serif;
  min-height: 100vh;
}

</style>
